export default "cf790334a5a6d45c.woff2"